
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { PartItem } from '@/features/shipment/types';
import { getPrice } from '@/features/common/helpers';
import PartsSummaryMobile from '@/features/shipment/components/commercialInvoice/mobileComponents/PartsSummaryMobile.vue';
import EditPartsItem from '@/features/shipment/components/commercialInvoice/EditPartsItem.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    PartsSummaryMobile,
    EditPartsItem,
  },
})
export default class PartsSummary extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) partsItems!: PartItem[];

  @Prop({ required: false, default: false }) showPids!: boolean;

  private showEditItem = false;

  private itemToEdit: PartItem & { index?: number } = this.partsItems[0];

  private getPrice = getPrice;

  private deleteItem(idx: number): void {
    eventBus.$once(eventNames.CONFIRMATION_DIALOG, () => {
      this.$emit('delete', idx);
    });

    this.$store.commit('toggleConfirmDialog', {
      show: true,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  private hasPids(item: PartItem): boolean {
    return !!(item.merchantProductId
      || item.manufacturerProductId
      || item.standardProductId);
  }

  private getTotal = (item: PartItem): number => item.quantity * item.unitValue;

  private getShipmentTotal(): number {
    return this.partsItems.reduce((a, b): number => a + this.getTotal(b), 0);
  }

  private openEdit(item: PartItem, idx: number) {
    this.itemToEdit = {
      ...item,
      index: idx,
    };
    this.showEditItem = true;
  }
}
